import styled from "styled-components";

export const TopCreatorsWrapper = styled.div`
  margin: 50px 0;
  width: 100%;
  overflow-x: scroll;
  & h3 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 36px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
    @media (max-width: 768.98px) {
      font-size: 32px;
    }
  }
  &::-webkit-scrollbar {
    opacity: 0;
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    height: 8px;
    width: 20px;
    background: linear-gradient(
      180deg,
      rgba(187, 187, 187, 0) 0%,
      #bbbbbb 36.94%
    );
    border-radius: 4px;
  }
`;

export const TopCreatorsMain = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  min-width: 1320px;
`;
